import { CreateMemberInfoDto } from '#types/member';
import { atom, useRecoilState } from 'recoil';

// 운동기록 생성 > 회원 사전 정보
const $memberInfoFormState = atom<CreateMemberInfoDto>({
  key: 'memberInfoFormState',
  default: {
    jobId: '',
    healthInfo: {
      height: 0,
      weight: 0,
      sleepingHourAvg: 0,
      qualityOfSleep: 0,
      diseases: [],
      painParts: [],
      surgeryParts: []
    },
    purposeIds: []
  }
});

export const useMemberInfoFormRecoil = () => {
  const [memberInfoForm, setMemberInfoForm] =
    useRecoilState($memberInfoFormState);

  return {
    memberInfoForm,
    setMemberInfoForm
  };
};
